import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import { getCustomerDetails } from "../../../services/customerService";
import { ICustomerDetails } from "../../../models/common/customer";
import { addErrorMsg } from "../../../framework/redux/slices/appSlice";
import { useAppDispatch } from "../../../framework/redux/hooks";
import { useTranslation } from "react-i18next";

interface IFormatDetailsContentProps {
    title: string;
    content: string | number;
    additionalContent?: string | number;
    displayAddress?: string;
    isInfoText?: boolean;
}

export const FormatDetailsContent = ({ title, content, displayAddress, isInfoText }: IFormatDetailsContentProps) => {
    const [selectedCustomer, setSelectedCustomer] = useState<ICustomerDetails | null>(null);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        if (displayAddress) {
            getCustomerDetails(displayAddress)
                .then((res) => {
                    setSelectedCustomer(res.data);
                })
                .catch((error) => {
                    console.error("Error fetching customer details:", error);
                    dispatch(addErrorMsg({ message: t("customer.addressFetchFailed") }));
                });
        }
    }, [displayAddress]);

    return (
        <>
            <Grid2 xs={5}>
                <Typography variant="subtitle2" sx={{ color: "primary.dark" }} component="span">
                    {title}
                </Typography>
            </Grid2>
            <Grid2 xs={7} marginBottom={isInfoText ? 1 : 0}>
                {displayAddress ? (
                    <>
                        <Typography
                            variant="subtitle2"
                            sx={{ color: "primary.dark" }}
                            component="span"
                        >
                            {content}
                        </Typography>
                        {selectedCustomer?.streetAddress && (
                        <Typography sx={{ fontSize: "small", color: "text.secondary" }}>
                            {selectedCustomer.streetAddress}
                        </Typography>
                        )}
                        {(selectedCustomer?.postalCode || selectedCustomer?.city) && (
                        <Typography sx={{ fontSize: "small", color: "text.secondary" }}>
                            {[selectedCustomer?.postalCode, selectedCustomer?.city]
                                .filter(Boolean)
                                .join(" ")}
                        </Typography>
                        )}
                        {selectedCustomer?.orderContactNumber && (
                        <Typography sx={{ fontSize: "small", color: "text.secondary" }}>
                            {selectedCustomer.orderContactNumber}
                        </Typography>
                        )}
                    </>
                ) : (
                    <>
                        {isInfoText ? (
                            <Typography
                                sx={{
                                    color: "text.secondary",
                                    fontSize: 12,
                                    fontStyle: "italic",
                                }}
                                component="span"
                            >
                                {content}
                            </Typography>
                        ) : (
                            <Typography
                                variant="subtitle2"
                                sx={{ color: "primary.dark" }}
                                component="span"
                            >
                                {content}
                            </Typography>
                        )}
                    </>
                )}
            </Grid2>
        </>
    );
};
